import { useEffect, useState } from 'react';

import { ThinkingSpinner } from './ThinkingSpinner';

import styles from './LoadingIndicator.module.css';

const thinkingPhrases = [
  'Thinking',
  'Pondering',
  'Mulling it over',
  'Crunching numbers',
  'Connecting the dots',
  'Brewing ideas',
  'Noodling on it',
  'Chewing on that',
  'Consulting the oracle',
  'Sifting through data',
  'Hatching a plan',
  'Warming up neurons',
];

const AnimatedDots = () => (
  <span aria-hidden>
    .<span className={styles.dot2}>.</span>
    <span className={styles.dot3}>.</span>
  </span>
);

export const LoadingIndicator = () => {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * thinkingPhrases.length),
  );

  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % thinkingPhrases.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.indicator}>
        <ThinkingSpinner size={14} className={styles.icon} />
        <span className={styles.text}>
          {thinkingPhrases[index]}
          <AnimatedDots />
        </span>
      </div>
    </div>
  );
};
